import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/InAppWidgetResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/pages/inappwidgets`;
	}
	listInAppWidgetsByProjectId(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/projectid`, { projectid: e }));
	}
};
//#endregion
export { n as InAppWidgetResource };

//# sourceMappingURL=InAppWidgetResource.js.map